import React, { useEffect } from 'react';
import { Button, Form, Input, message, Select, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { doGetHubs } from '../../modules/hubs/stores/thunk';
import { selectAllHubs } from '../../modules/hubs/stores/slice';

const initForm = {
  name: '',
  tag: 'BIKE',
  hubId: undefined,
  weight: undefined,
  volume: undefined,
  status: 'FUNCTIONAL',
};
const FleetForm = ({ handleSubmit, action, fleet, handleCancel }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation('fleet');
  const { t: tc } = useTranslation('common');

  const dispatch = useDispatch();
  const isFetching = useSelector((state) => state.hub.isFetching);

  useEffect(() => {
    dispatch(doGetHubs({ page: 1, take: 100000 }));
  }, []);

  const hubs = useSelector((state) => selectAllHubs(state));

  // eslint-disable-next-line no-unused-vars
  const [messageApi, contextHolder] = message.useMessage();

  const setParams = (values) => {
    const params = { ...values };
    if (params.weight) {
      params.weight = Number(params.weight);
    }
    if (params.volume) {
      params.volume = Number(params.volume);
    }

    return params;
  };
  const onFinishForm = (values) => {
    handleSubmit && handleSubmit(setParams(values));
  };

  useEffect(() => {
    if (action === 'new') {
      form.setFieldsValue(initForm);
    } else if (fleet) {
      form.setFieldsValue({
        ...fleet,
      });
    }
  }, [action, fleet]);

  return (
    <Spin spinning={isFetching}>
      <div className="FleetForm">
        {contextHolder}
        <div className="FormHeader"></div>
        <div className="FormContent">
          <Form
            form={form}
            scrollToFirstError
            layout="vertical"
            requiredMark={false}
            colon={false}
            onFinish={onFinishForm}
          >
            <Form.Item label={t('name')} name="name" rules={[{ required: true, message: tc('required') }]}>
              <Input placeholder={t('name')} />
            </Form.Item>
            <Form.Item label={t('tag')} name="tag" rules={[{ required: true, message: tc('required') }]}>
              <Select
                placeholder={t('selectTag')}
                options={Object.keys(tc('fleetTags', { returnObjects: true })).map((key) => ({
                  value: key,
                  label: tc(`fleetTags.${key}`),
                }))}
              />
            </Form.Item>
            <Form.Item label={t('hub')} name="hubId" rules={[{ required: true, message: tc('required') }]}>
              <Select
                placeholder={t('selectHub')}
                options={hubs.map((hub) => ({
                  value: hub.id,
                  label: hub.name,
                }))}
              />
            </Form.Item>
            <Form.Item label={t('weight')} name="weight">
              <Input type="number" placeholder={t('weight')} suffix="kg" />
            </Form.Item>
            <Form.Item
              label={t('volume')}
              name="volume"
              rules={[
                {
                  validator: (_, value) => {
                    if (!value || (value && value <= 75)) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject(new Error(t('volumeMax')));
                    }
                  },
                },
              ]}
            >
              <Input type="number" max={75} step={0.001} placeholder={t('volume')} suffix="m3" />
            </Form.Item>
            <Form.Item label={t('status')} name="status" rules={[{ required: true, message: tc('required') }]}>
              <Select
                placeholder={t('selectStatus')}
                options={Object.keys(tc('fleetStatuses', { returnObjects: true })).map((key) => ({
                  value: key,
                  label: tc(`fleetStatuses.${key}`),
                }))}
              />
            </Form.Item>
          </Form>
        </div>
        <div className="FormFooter">
          <Button key="cancel" onClick={handleCancel}>
            {tc('cancel')}
          </Button>
          <Button type="primary" block size="large" onClick={() => form.submit()}>
            {action === 'new' ? tc('create') : tc('update')}
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default FleetForm;
